import { useContext } from 'react'
import { StencilContext } from './ProvideStencilContext/ProvideStencilContext'

export const useStencilNavigation = () => {
  const context = useContext(StencilContext)
  if (!context) {
    throw new Error('useStencil: no context provided')
  }

  return context
}
